// components/SuccessEdge.tsx
import { EdgeLabelRenderer, getSmoothStepPath } from '@xyflow/react';
import AddIcon from '@mui/icons-material/Add';
 

export const SuccessEdge = ({ id, sourceX, sourceY, targetX, targetY, onClick, source, target, data }: any) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY
  });

  // const [isHovered, setIsHovered] = useState(false);

 

  const handlePlusClick = (event: React.MouseEvent) => {
    
    event.preventDefault();
    event.stopPropagation();
    
    if (onClick) {
     
      // Pass edge information including parent (source) and child (target)
      onClick({
        edgeId: id,
        parentNodeId: source,
        childNodeId: target,
        edgeData: data,
        position: { x: labelX, y: labelY },
        edgeType: 'onCompleteStep' // Add edge type for API payload
      });
    } else {
    
    }
  };

  return (
    <>
      {/* Marker definition must be in the DOM */}
      <svg style={{ height: 0 }}>
        <defs>
          <marker
            id="failed-arrow"
            markerWidth="18"
            markerHeight="6"
            viewBox="0 0 10 8"
            refX="10"
            refY="4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M 0 0 L 10 4 L 0 8 z" fill="black" />
          </marker>
        </defs>
      </svg>

      {/* Edge path with arrow marker */}
      <path
        id={id}
        d={edgePath}
        className="react-flow__edge-path"
        style={{ stroke: 'green', strokeWidth: 2 }}
        fill="none"
        markerEnd="url(#failed-arrow)"
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 20,
            background: 'white',
            padding: '4px', 
            color: 'green',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '24px',
            height: '24px',
            userSelect: 'none',
             
            pointerEvents: 'all',
             border:'2px solid green' 
          }}
          onClick={handlePlusClick}
          onMouseDown={(e) => { e.stopPropagation(); e.preventDefault(); }}
          // onMouseEnter={() => setIsHovered(true)}
          //  onMouseLeave={() => setIsHovered(false)}
          onMouseUp={(e) => { e.stopPropagation(); e.preventDefault(); }}
          onPointerDown={(e) => { e.stopPropagation(); e.preventDefault(); }}
          onPointerUp={(e) => { e.stopPropagation(); e.preventDefault(); }}
        >
          <AddIcon style={{ color: 'green', fontSize: 20 }} />
        </div>
      </EdgeLabelRenderer>
    </>
  );
};
